import { useTranslation } from "react-i18next";
import { TextField } from "@/shared/ui/core";
import { RepeatableList, TextAreaField } from "@/features/admin/components";
import { EditorialBlock, type EditorialBlockLocaleProps } from "./EditorialBlock";
import { EditorialIconField } from "./EditorialIconField";
import { useBlockFilled } from "./useBlockFilled";

/**
 * Bloque 4 · Los pilares: por qué este producto es lo que dice ser.
 *
 * El TÍTULO del bloque es obligatorio en cuanto hay un pilar escrito.
 * No es capricho del formulario: el contrato lo exige, y sin este aviso
 * el error saldría al pulsar guardar, señalando un campo que quien
 * escribió los pilares ni siquiera miró.
 */
export function EditorialPillarsBlock({ locale }: EditorialBlockLocaleProps) {
  const { t } = useTranslation();
  const name = `editorial.${locale}.pillars`;
  const filled = useBlockFilled(name);

  return (
    <EditorialBlock
      name={name}
      title={t("Pilares")}
      description={t("De tres a cuatro razones, cada una con su icono.")}
      filled={filled}
    >
      <TextField
        name={`${name}.title`}
        label={t("Título del bloque")}
        placeholder={t("Por qué funciona")}
      />
      <TextAreaField
        name={`${name}.intro`}
        label={t("Entradilla")}
        rows={2}
        hint={t("Opcional. Un párrafo antes de los pilares.")}
      />

      <div className="sm:col-span-2">
        <RepeatableList
          name={`${name}.items`}
          max={12}
          addLabel={t("Añadir pilar")}
          itemLabel={(index) => t("Pilar {{n}}", { n: index + 1 })}
          emptyHint={t("Todavía no hay pilares. Añade el primero.")}
          newItem={() => ({ icon: "", title: "", description: "" })}
        >
          {({ name: row }) => (
            <div className="grid grid-cols-1 items-start gap-4 sm:grid-cols-2">
              <TextField
                name={`${row}.title`}
                label={t("Título del pilar")}
                placeholder={t("Absorción real")}
              />
              <EditorialIconField name={`${row}.icon`} />
              <TextAreaField
                name={`${row}.description`}
                label={t("Descripción")}
                rows={3}
                fieldClassName="sm:col-span-2"
              />
            </div>
          )}
        </RepeatableList>
      </div>
    </EditorialBlock>
  );
}
